import React, { Fragment } from 'react';
import PageTitle from '../../components/pagetitle/PageTitle';
import Header from '../../components/header/Header';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import TopCoinProtectionPolicyContent from '../../components/TopCoinProtectionPolicy/TopCoinProtectionPolicy';

const TopCoinProtectionPolicyPage = (props) => {

    return (
        <Fragment>
            <div className='index_ico page_wrapper'>
                <Header />
                <main className="page_content">
                    <PageTitle pageTitle={'TopCoin Protection & Platform Security Policy'} pagesub={'Home'} />
                    <TopCoinProtectionPolicyContent abClass={'pt-0'}/>
                </main>
                <Footer />
                <Scrollbar />
            </div>
        </Fragment>
    )
};
export default TopCoinProtectionPolicyPage;
